import React from "react";
import useDashboard from "../../hooks/dashboard/useDashboard";
import Loading from "../../components/common/Loading";
import DashboardItems from "components/dashboard/DashboardItems";

const Dashboard = () => {
  const {
    isLoading,
    predictionsLength,
    promisesLength,
    predictorsLength,
    surveysLength,
  } = useDashboard();

  return isLoading ? (
    <Loading />
  ) : (
    <DashboardItems
      lengths={{
        predictions: predictionsLength,
        promises: promisesLength,
        predictors: predictorsLength,
        surveys: surveysLength,
      }}
    />
  );
};

export default Dashboard;
